import CommonHospitalLoginPage from "pages/CommonHospitalLoginPage/CommonHospitalLoginPage";
import RadiologyOrderWorklist from "pages/RadiologyManagement/RadiologyOrderWorklist";
import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

const Sidebar1 = React.lazy(() => import("components/Sidebar1"));
const ApponitmentDoctorList = React.lazy(
  () => import("pages/OPD/Appointments/ApponitmentsDoctorList")
);
const PatientList = React.lazy(
  () => import("pages/OPD/Appointments/PatientList")
);
const GynecologyPage = React.lazy(
  () => import("pages/Gynecology/GynecologyPage")
);
const PostOperationTemplate = React.lazy(
  () => import("pages/PostOperationTemplate/PostOperationTemplate")
);
const AddPostOperationTemplate = React.lazy(
  () => import("pages/PostOperationTemplate/AddPostOperationTemplate")
);
const IPDRegisterReport = React.lazy(
  () => import("pages/IPDRegisterReport/IPDRegisterReport")
);


const GynecologyPageAfterObstetricUsg = React.lazy(
  () => import("pages/Gynecology/AfterObstetricUsg2")
);
const GynecologyPageBeforeObstetricUsg = React.lazy(
  () => import("pages/Gynecology/BeforeObstetricUsg")
);
const Form1 = React.lazy(() => import("pages/Gynecology/Form1"));

const PostOperationOrders = React.lazy(
  () => import("pages/Gynecology/PostOperationOrders")
);

const BookAppointmentByDoctor = React.lazy(
  () => import("pages/OPD/Appointments/BookAppointmentByDoctor")
);
const ConsultationAll = React.lazy(
  () => import("pages/OPD/Appointments/Consultaion/ConsultationAll")
);
const VaccinationDue = React.lazy(() => import("pages/OPD/VaccinationDue"));
const AddNewMedicines = React.lazy(
  () => import("pages/OPD/Appointments/Consultaion/Components/AddNewMedicine")
);
const AfterObstetricUsg = React.lazy(
  () =>
    import("pages/OPD/Appointments/Consultaion/Components/AfterObstetricUsg")
);
const BeforeObstetricUsg = React.lazy(
  () =>
    import("pages/OPD/Appointments/Consultaion/Components/BeforeObstetricUsg")
);
const AddPatientByDoctor = React.lazy(
  () => import("pages/OPD/Appointments/AddPatientByDoctor")
);
const Billing = React.lazy(
  () => import("pages/OPD/Appointments/Consultaion/Components/Billing")
);
const Sidebar2 = React.lazy(() => import("components/Sidebar2"));
const HospitalSettingDetails = React.lazy(
  () => import("pages/Hospital Setting/HospitalSettingDetails")
);
const BillableItemsAddOpdBill = React.lazy(
  () => import("pages/Hospital Setting/BillableItems/AddOpdBill")
);
const BillableItemsEditOpdBill = React.lazy(
  () => import("pages/Hospital Setting/BillableItems/EditOPdBill")
);
const RevenueReports = React.lazy(
  () => import("pages/RevenueReports/RevenueReports")
);
const NewPientsReports = React.lazy(
  () => import("pages/NewPientsReports/NewPientsReports")
);
const SpecialzationAdd = React.lazy(
  () => import("pages/Hospital Setting/Specializations/SpecialzationAdd")
);
const EditPatient = React.lazy(() => import("pages/PatientPages/EditPatient"));
const SpecializationUpdate = React.lazy(
  () => import("pages/Hospital Setting/Specializations/SpecializationUpdate")
);
const AddSymptoms = React.lazy(
  () => import("pages/Hospital Setting/Symptoms/AddSymptoms")
);
const OldPatientReports = React.lazy(
  () => import("pages/OldPatientrReports/OldPatientReports")
);
const TopSymptomsReports = React.lazy(
  () => import("pages/TopSymptomsReports/TopSymptomsReports")
);
const UsgPreliminaryReport = React.lazy(
  () => import("pages/UsgPreliminaryReport/UsgPreliminaryReport")
);
const OperationTheaterBookingReport = React.lazy(
  () => import("pages/OperationTheaterBookingReport/OperationTheaterBookingReport")
);
const AnaesthetistProcedureReport = React.lazy(
  () => import("pages/AnaesthetistProcedureReport/AnaesthetistProcedureReport")
);
const TopDianosisreport = React.lazy(
  () => import("pages/TopDiagnosisReport/TopDianosisreport")
);
const SpecializationImageView = React.lazy(
  () => import("pages/Hospital Setting/Specializations/SpecializationImageView")
);
const UpdateSpecialization = React.lazy(
  () => import("pages/Hospital Setting/Specializations/UpdateSpecialization")
);

const HomeOne = React.lazy(() => import("pages/HomeOne"));
const MultispecialtyHospital = React.lazy(
  () => import("pages/MultispecialtyHospital/MultispecialtyHospital")
);
const PatientHome = React.lazy(() => import("pages/PatientHome/PatientHome"));
const Appointments = React.lazy(
  () => import("pages/PatientPages/Appointments")
);
const AddNewPatient = React.lazy(
  () => import("pages/PatientPages/AddNewPatient")
);
const AddNewPatientProfile = React.lazy(
  () => import("pages/PatientPages/AddNewPatientProfile")
);
const AppointmentUploadReport = React.lazy(
  () => import("pages/PatientPages/AppointmentUploadReport")
);
const AllFamilyMembers = React.lazy(
  () => import("pages/PatientPages/AllFamilyMembers")
);
const BookByDoctor = React.lazy(
  () => import("pages/PatientBookAppointment/BookByDoctor")
);
const BookAppointmentSymptom = React.lazy(
  () => import("pages/PatientBookAppointment/BookAppointmentSymptom")
);
const BookBySpecialization = React.lazy(
  () => import("pages/PatientBookAppointment/BookBySpecialization")
);
const BookBySymptom = React.lazy(
  () => import("pages/PatientBookAppointment/BookBySymptom")
);
const BookAppointmentSlot = React.lazy(
  () => import("pages/PatientBookAppointment/BookAppointmentSlot")
);
const ViewPatientProfile = React.lazy(
  () => import("pages/PatientPages/ViewPatientProfile")
);
const ViewProfile = React.lazy(() => import("pages/PatientPages/ViewProfile"));
const UpdatePasswardPatient = React.lazy(
  () => import("pages/PatientPages/UpdatePasswardPatient")
);
const UpdateMedicine = React.lazy(
  () => import("pages/Hospital Setting/Medicine/MedicineUpdate")
);
const AddHospitalTest = React.lazy(
  () => import("pages/Hospital Setting/HospitalTests/AddHospitalTest")
);
const AddTestCategory = React.lazy(
  () => import("pages/Hospital Setting/HospitalTests/AddTestCategory")
);
const UpdateHospitalTestCategory = React.lazy(
  () =>
    import("pages/Hospital Setting/HospitalTests/UpdateHospitalTestCategory")
);
const EditHospitalTest = React.lazy(
  () => import("pages/Hospital Setting/HospitalTests/EditHospitalTest")
);
const HospitalAllTest = React.lazy(
  () => import("pages/Hospital Setting/HospitalTests/HospitalAllTest")
);
const PasswordResetForm = React.lazy(
  () => import("pages/Forgot Password/PasswordResetForm")
);
const OTPForm = React.lazy(() => import("pages/Forgot Password/OTPForm"));
const OTPFormDoctors = React.lazy(
  () => import("pages/Forgot Password/OTPFormDoctors")
);
const PasswordResetFormDoctors = React.lazy(
  () => import("pages/Forgot Password/PasswordResetFormDoctors")
);

const DoctorsOne = React.lazy(() => import("pages/DoctorsOne"));
const MotherChildCare = React.lazy(() => import("pages/Motherandchildcare"));
const AboutUs = React.lazy(() => import("pages/Aboutus"));
const Contact = React.lazy(() => import("pages/Contact"));
const Speciality = React.lazy(() => import("pages/Speciality/Speciality"));
const Privacy = React.lazy(() => import("pages/PrivacyPolicy/Privacy"));
const LogInEmpty = React.lazy(() => import("pages/LogInPage/LogInEmpty"));
const CreateUser = React.lazy(() => import("pages/CreateUser/CreateUser"));
const LoginDoctor = React.lazy(() => import("pages/LogInPage/LoginDoctor"));
const DoctorHome = React.lazy(() => import("pages/DoctorHome/DoctorHome"));
const Appointmentsmanagements = React.lazy(
  () => import("pages/Appointments Managements/Appointmentsmanagements")
);
const UpdatePatientAppointmentsmanagements = React.lazy(
  () => import("pages/Appointments Managements/UpdatePatient")
);
const MyPatient = React.lazy(() => import("pages/OPD/MyPatient/MyPatient"));
const AllOpdHistory = React.lazy(() => import("pages/OPD/MyPatient/AllOpdHistory"));
const OpdHistoryAllObstetricUsg = React.lazy(() => import("pages/OPD/MyPatient/OpdHistoryAllObstetricUsg"));
const OPdHistoryPersonalNote = React.lazy(() => import("pages/OPD/MyPatient/OPdHistoryPersonalNote"));
const OpdHistoryNew = React.lazy(() => import("pages/OPD/MyPatient/OpdHistoryNew"));
const OpdHistoryPreExistingConditions = React.lazy(() => import("pages/OPD/MyPatient/OpdHistoryPreExistingConditions"));
const OpdHistoryUploadConsultationReport = React.lazy(() => import("pages/OPD/MyPatient/OpdHistoryUploadConsultationReport"));


const MypatientUpdatePatient = React.lazy(
  () => import("pages/OPD/MyPatient/UpdatePatient")
);
const BookAppointment = React.lazy(
  () => import("pages/Appointments Managements/BookAppointment")
);
const AddPatient = React.lazy(
  () => import("pages/Appointments Managements/AddPatient")
);
const MarkPaid = React.lazy(
  () => import("pages/Appointments Managements/MarkPaid")
);
const BookappointmentAdd = React.lazy(
  () => import("pages/Appointments Managements/BookappointmentAdd")
);
const UploadReport = React.lazy(
  () => import("pages/Appointments Managements/UploadReport")
);
const USGPreliminaryFrom = React.lazy(
  () => import("pages/Appointments Managements/USGPreliminaryFrom")
);
const AddVitals = React.lazy(
  () => import("pages/Appointments Managements/AddVitals")
);
const AddBillView = React.lazy(
  () => import("pages/Appointments Managements/AddBillView")
);
const OpdBill = React.lazy(
  () => import("pages/Appointments Managements/OpdBill")
);
const AddNewSymtoms = React.lazy(
  () => import("pages/OPD/Appointments/Consultaion/Components/AddNewSymtoms")
);
const DoctorUSGPreliminaryFrom = React.lazy(
  () =>
    import(
      "pages/OPD/Appointments/Consultaion/Components/DoctorUSGPreliminaryFrom"
    )
);
const AddNewInstruction = React.lazy(
  () =>
    import("pages/OPD/Appointments/Consultaion/Components/AddNewInstruction")
);
const UsersList = React.lazy(() => import("pages/UserManagement/UsersList"));
const UserReferral = React.lazy(() => import("pages/UserManagement/UserReferral"));
const AddUser = React.lazy(() => import("pages/UserManagement/AddUser"));
const EditUser = React.lazy(() => import("pages/UserManagement/EditUser"));
const UserProfileAll = React.lazy(
  () => import("pages/UserManagement/UserProfileAll")
);
const UserAccess = React.lazy(
  () => import("pages/UserManagement/UserAccess/UserAccess")
);
const UserImageAddUpdate = React.lazy(
  () => import("pages/UserManagement/UserImageAddUpdate")
);
const OPDManagementAll = React.lazy(
  () => import("pages/OPDManagement/OPDManagementAll")
);
const MyProfileImageAddUpdate = React.lazy(
  () => import("pages/OPDManagement/MyProfileImageAddUpdate")
);
const PatientDelete = React.lazy(
  () => import("pages/PatientDelete/PatientDelete")
);
const PatientManagementList = React.lazy(
  () => import("pages/PatientManagement/PatientList")
);
const PatientManagementAddPatient = React.lazy(
  () => import("pages/PatientManagement/AddPatient")
);
const PatientManagementUpdatePatient = React.lazy(
  () => import("pages/PatientManagement/UpdatePatient")
);
const MyProfile = React.lazy(() => import("pages/MyProfile/MyProfile"));
const UserProfileDocuments = React.lazy(
  () => import("pages/MyProfile/UserProfileDocuments")
);

const RoomBookingAdmissionDetails = React.lazy(
  () => import("pages/RoomBooking/AdmissionDetails")
);

const RoomBookingAddPatient = React.lazy(
  () => import("pages/RoomBooking/AddPatient")
);
const RoomBookingEditPatient = React.lazy(
  () => import("pages/RoomBooking/EditPatient")
);
const IPDEditPatient = React.lazy(
  () => import("pages/RoomBooking/IPDEditPatient")
);
const RoomBookingPatientManage = React.lazy(
  () => import("pages/RoomBooking/PatientManage")
);
const IpdDetails = React.lazy(() => import("pages/IPDDetails/IpdDetails"));
const IpdTpaInsurance = React.lazy(
  () => import("pages/IPDDetails/IpdTpaInsurance")
);
const TpaReports = React.lazy(() => import("pages/IPDDetails/TpaReports"));
const RoomBooking = React.lazy(() => import("pages/RoomBooking/RoomBook"));
const CheckBedAvailability = React.lazy(
  () => import("pages/RoomBooking/CheckBedAvailability")
);
const CheckBedAvailabilitytwo = React.lazy(
  () => import("pages/RoomBooking/CheckBedAvailabilitytwo")
);
const ManagePatientRoomBookin = React.lazy(
  () => import("pages/RoomBooking/ManagePatientRoomBookin")
);

const IPDBillingSetup = React.lazy(
  () => import("pages/IPDBillingSetup/IPDBillingSetup")
);
const IPDBedSetup = React.lazy(() => import("pages/IPDBedSetup/IPDBedSetup"));
const ReliginDisplay = React.lazy(() => import("pages/Religin/Religin"));
const IpdWardcreate = React.lazy(
  () => import("pages/IPDBedSetup/IPDWard/IpdWardcreate")
);
const IpdWardUpdate = React.lazy(
  () => import("pages/IPDBedSetup/IPDWard/IpdWardUpdate")
);
const IpdBedcreate = React.lazy(
  () => import("pages/IPDBedSetup/IPDBed/IpdBedcreate")
);
const IpdBedUpdate = React.lazy(
  () => import("pages/IPDBedSetup/IPDBed/IpdBedUpdate")
);
const IpdWardTypecreate = React.lazy(
  () => import("pages/IPDBedSetup/IPDWardType/IpdWardTypecreate")
);
const IpdWrdTypeUpdate = React.lazy(
  () => import("pages/IPDBedSetup/IPDWardType/IpdWrdTypeUpdate")
);
const AddNewBillItem = React.lazy(
  () => import("pages/IPDBillingSetup/IPDBillItems/AddNewBillItem")
);
const UpdateNewBillItem = React.lazy(
  () => import("pages/IPDBillingSetup/IPDBillItems/EditBillItem")
);
const AddNewBillCategory = React.lazy(
  () => import("pages/IPDBillingSetup/IPDBillCategory/AddNewBillCategory")
);
const UpdateNewBillCategory = React.lazy(
  () => import("pages/IPDBillingSetup/IPDBillCategory/UpdateNewBillCategory")
);

const IPDBillAndPay = React.lazy(
  () => import("pages/IPDBillAndPay/IPDBillAndPay")
);
const IPDDischargeMain = React.lazy(
  () => import("pages/IPDDischarge/IPDDischargeMain")
);
const IPDDischargeSetup = React.lazy(
  () => import("pages/IPDDischargeSetup/IPDDischargeSetup")
);
const IPDDichargeCheckListUpdate = React.lazy(
  () => import("pages/IPDDischargeSetup/IPDDichargeCheckListUpdate")
);
const ObstetricUsglistUpdate = React.lazy(
  () =>
    import("pages/Hospital Setting/ObstetricUsgSetup/ObstetricUsglistUpdate")
);
const IPDTamplateNavTab = React.lazy(
  () => import("pages/IPDMasterTemplates/IPDTamplateNavTab")
);
const EditIPDMasterTemplate = React.lazy(
  () => import("pages/IPDMasterTemplates/EditIPDMasterTemplate")
);
const AddIPDMasterTemplate = React.lazy(
  () => import("pages/IPDMasterTemplates/AddIPDMasterTemplate")
);
const IPDDischargeSummaryForAndroid = React.lazy(
  () => import("pages/IPDDischarge/IPDDischargeSummaryForAndroid")
);

const DigiTonicLogin = React.lazy(() => import("pages/DigiTonic/LogInPage"));
const ForgotPassword = React.lazy(
  () => import("pages/DigiTonic/ForgotPassword")
);
const PassWordReset = React.lazy(() => import("pages/DigiTonic/PassWordReset"));

const SantTukaramHospital = React.lazy(
  () => import("pages/SantTukaramHospital/LogInPage")
);
const SantTukaramHospitalNewPatient = React.lazy(
  () => import("pages/SantTukaramHospital/PatientCreateNewAccount")
);
const SantTukaramHospitalPatientForgotPassword = React.lazy(
  () => import("pages/SantTukaramHospital/PatientForgotPassWord")
);
const SantTukaramHospitalPatientResetPaword = React.lazy(
  () => import("pages/SantTukaramHospital/PatientResetPaword")
);

const SurgeryList = React.lazy(() => import("pages/SurgeryList/SurgeryList"));
const OperationNoteslist = React.lazy(
  () => import("pages/OperationNotesSetup/GynecologyOperationNotesList")
);
const OperationNotesadd = React.lazy(() => import("pages/OperationNotesSetup/OperationNotesadd"));
const GynecologyOperationNotesAdd = React.lazy(() => import("pages/OperationNotesSetup/GynecologyOperationNotesAdd"));
const NewOperationNotesAddupdate = React.lazy(() => import("pages/OperationNotesSetup/OperationNotesAddUpdate"));
const GynecologyOperationNotesupdate = React.lazy(() => import("pages/OperationNotesSetup/GynecologyOperationNotesupdate"));
const SurgeryListAdd = React.lazy(
  () => import("pages/SurgeryList/SurgeryListAdd")
);
const SurgeryListEdit = React.lazy(
  () => import("pages/SurgeryList/SurgeryListEdit")
);
const OperationTheater = React.lazy(
  () => import("pages/Operation Theater/OperationTheater")
);
const OperationTheaterEdit = React.lazy(
  () => import("pages/Operation Theater/OperationTheaterEdit")
);
const OperationTheaterBookingList = React.lazy(
  () => import("pages/Operation Theater Booking/OperationTheaterBookingList")
);
// const Indication = React.lazy(() => import("pages/Indication/AllIndication"));
// const EditIndication = React.lazy(
//   () => import("pages/Indication/EditIndication")
// );
// const AddNewIndication = React.lazy(
//   () => import("pages/Indication/AddNewIndication")
// );

const AddOTBooking = React.lazy(
  () => import("pages/Operation Theater Booking/AddOTBooking")
);
const UpdateOTBooking = React.lazy(
  () => import("pages/Operation Theater Booking/UpdateOTBooking")
);

const ReportUSGPatient = React.lazy(
  () => import("pages/ReportUSGPatient/ReportUSGPatient")
);
const ReportPreExistingCondition = React.lazy(
  () => import("pages/ReportPreExistingCondition/ReportPreExistingCondition")
);
const MyReport = React.lazy(() => import("pages/MyReports/MyReport"));
const HospitalReport = React.lazy(
  () => import("pages/HospitalReports/HospitalReports")
);

// Hospital Revenue Reports
// OPD Revenue Reports
const OPDRevenueReports = React.lazy(() => import("pages/HospitalRevenueReports/OPDRevenueReports/OpdRevenueReportsMain"));
// IPD Revenue Reports
const IPDRevenueReports = React.lazy(() => import("pages/HospitalRevenueReports/IPDRevenueReports/IpdRevenueReportsMain"));
// hospital lab Masters
const LabSetting = React.lazy(() => import("pages/LabMasterSetting/LabSetting"));

const IPDTemplateCategoryEdit = React.lazy(
  () => import("pages/IPDTemplateCategory/IPDTemplateCategoryEdit")
);

// Lab Management

// dashboard
const Dashboard = React.lazy(
  () => import("pages/LabManagement/LabDashboard")
);

//lab Orders 
const LabOrders = React.lazy(
  () => import("pages/LabManagement/LabOrders")
);

//lab pending request
const IncomingLabRequest = React.lazy(
  () => import("pages/LabManagement/IncomingLabRequest")
);

//sample collection
const SampleCollection = React.lazy(
  () => import("pages/LabManagement/SampleCollection")
);
const SampleCollectionDetail = React.lazy(
  () => import("pages/LabManagement/SampleCollectionDetails")
);
//lab worklist
const LabWorklist = React.lazy(
  () => import("pages/LabManagement/LabWorklist")
);

const LabWorklistDetail = React.lazy(
  () => import("pages/LabManagement/LabWorklistDetails")
);

//test verification
const LabTestVerification = React.lazy(
  () => import("pages/LabManagement/LabTestVerification")
);
//test report
const LabReport = React.lazy(
  () => import("pages/LabManagement/LabReport")
);

//Lab Bill
const LabBillAndPay = React.lazy(
  () => import("pages/LabManagement/LabBillAndPay")
);

// barcode print
const PrintLabels = React.lazy(
  () => import("pages/LabManagement/PrintLabels")
);

// radiology pending request
const IncomingRadiologyRequest = React.lazy(
  () => import("pages/RadiologyManagement/IncomingRadiologyRequest")
);


const RadiologyOrder = React.lazy(
  () => import("pages/RadiologyManagement/RadiologyOrder")
);

const Radiologyworklist = React.lazy(
  () => import("pages/RadiologyManagement/RadiologyOrderWorklist")
);

const RadiologyworklistDetail = React.lazy(
  () => import("pages/RadiologyManagement/RadiologyWorklistDetails")
);
const Radiologyverification = React.lazy(
  () => import("pages/RadiologyManagement/Radiologyverification")
);

const RadiologyReports = React.lazy(
  () => import("pages/RadiologyManagement/RadiologyReports")
);
//Lab Bill
const RadiologyBillAndPay = React.lazy(
  () => import("pages/RadiologyManagement/RadiologyBillAndPay")
);


// IPd consultation 
const IpdConsultation = React.lazy(
  () => import("pages/IPDDoctorVisit/IpdConsultationAll")
);
// IPD  doctor records entry
const IpdHistory = React.lazy(
  () => import("pages/IPDDoctorVisit/IpdHistory")
);

// hospital service master category
const IPDSettings = React.lazy(
  () => import("pages/IPDSettings/IPDSettings")
);

const OPDSettings = React.lazy(
  () => import("pages/OPDSettings/OPDSettings")
);


const LabAddPatient = React.lazy(
  () => import("pages/LabManagement/LabAddPatient")
);
const HsnSacMaster = React.lazy(
  () => import("pages/HsnSacCodeManagement/HsnSacMaster")
);
// const SacUpdate = React.lazy(
//   () => import("pages/HsnSacCodeManagement/SAC/SacUpdate")
// );

// Pharmacy module
const PharmacyPendingPrescriptions = React.lazy(
  () => import("pages/Pharmacy/PendingPrescriptions")
);
const PharmacyDispenseHistory = React.lazy(
  () => import("pages/Pharmacy/DispenseHistory")
);
const PharmacyStockInventory = React.lazy(
  () => import("pages/Pharmacy/StockInventory")
);
const PharmacyGrnList = React.lazy(() => import("pages/Pharmacy/Grn/GrnList"));
const PharmacyGrnCreate = React.lazy(() => import("pages/Pharmacy/Grn/GrnCreate"));
const PharmacyPurchaseOrderList = React.lazy(
  () => import("pages/Pharmacy/PurchaseOrder/PurchaseOrderList")
);
const PharmacyStockTransferList = React.lazy(
  () => import("pages/Pharmacy/StockTransfer/StockTransferList")
);
const PharmacyAgeingReport = React.lazy(() => import("pages/Pharmacy/AgeingReport"));
const PharmacySettings = React.lazy(
  () => import("pages/Pharmacy/Settings/PharmacySettings")
);
const PharmacyUserGuide = React.lazy(() => import("pages/Pharmacy/UserGuide"));
const PharmacyStockAdjustment = React.lazy(
  () => import("pages/Pharmacy/StockAdjustment/StockAdjustmentList")
);
const PharmacySupplierReturn = React.lazy(
  () => import("pages/Pharmacy/SupplierReturn/SupplierReturnList")
);
const PharmacySupplierAdjustment = React.lazy(
  () => import("pages/Pharmacy/SupplierAdjustment/SupplierAdjustmentList")
);
const PharmacySupplierReports = React.lazy(
  () => import("pages/Pharmacy/SupplierReportsPage")
);
const PharmacyRevenueReports = React.lazy(
  () => import("pages/Pharmacy/RevenueReportsPage")
);
const PharmacyPatientReturn = React.lazy(
  () => import("pages/Pharmacy/PatientReturn/PatientReturnList")
);
const PharmacyExpiryWriteoff = React.lazy(
  () => import("pages/Pharmacy/ExpiryWriteoff/ExpiryWriteoffList")
);
const PharmacyPrintMedicineBarcode = React.lazy(() => import("pages/Pharmacy/PrintMedicineBarcode"));
const PharmacyPrintInvoice = React.lazy(() => import("pages/Pharmacy/PrintPharmacyInvoice"));
const AssessmentSelfServicePage = React.lazy(() => import("pages/Assessment/SelfServicePage"));
const PharmacyRegulatedRegister = React.lazy(
  () => import("pages/Pharmacy/RegulatedRegister/RegulatedRegisterList")
);
const PharmacyPrintRegulatedRegister = React.lazy(() => import("pages/Pharmacy/PrintRegulatedRegister"));
const PharmacyStockTake = React.lazy(() => import("pages/Pharmacy/StockTake/StockTakeSession"));
const PharmacyAbcVedAnalysis = React.lazy(
  () => import("pages/Pharmacy/AbcVedAnalysis/AbcVedAnalysisList")
);
const PharmacyPrintAbcVedAnalysis = React.lazy(() => import("pages/Pharmacy/PrintAbcVedAnalysis"));

// HRMS module (Release 1.1 -- Foundation, 1.2 -- Personnel & Employee,
// 1.3 -- Attendance & Shift, 1.4 -- Leave & Holiday -- completes Release 1;
// Release 2 -- Payroll & Statutory; Release 3.2 -- Doctor/Consultant Payout;
// Release 3.1 -- Employee & Manager Self-Service)
const HrmsDashboard = React.lazy(() => import("pages/HRMS/Dashboard"));
const HrmsSettings = React.lazy(() => import("pages/HRMS/Settings/HrmsSettings"));
const HrmsAuditLog = React.lazy(() => import("pages/HRMS/AuditLog"));
const HrmsPersonnel = React.lazy(() => import("pages/HRMS/Personnel"));
const HrmsAttendance = React.lazy(() => import("pages/HRMS/Attendance"));
const HrmsLeave = React.lazy(() => import("pages/HRMS/Leave"));
const HrmsPayroll = React.lazy(() => import("pages/HRMS/Payroll"));
const HrmsDoctorPayout = React.lazy(() => import("pages/HRMS/DoctorPayout"));
const HrmsSettlementDetail = React.lazy(() => import("pages/HRMS/SettlementDetailPage"));
const HrmsMyProfile = React.lazy(() => import("pages/HRMS/MyProfile"));
const HrmsMyTeam = React.lazy(() => import("pages/HRMS/MyTeam"));
const HrmsUserGuide = React.lazy(() => import("pages/HRMS/UserGuide"));

// Hospital Asset Management module -- seeded from a real customer Fixed
// Asset Register physical-verification file (see asset-database.sql).
const AssetAssets = React.lazy(() => import("pages/Asset/Assets"));
const AssetDetail = React.lazy(() => import("pages/Asset/AssetDetail"));
const AssetAmcExpiring = React.lazy(() => import("pages/Asset/AmcExpiring"));
const AssetBulkUpload = React.lazy(() => import("pages/Asset/AssetBulkUpload"));
const AssetUserGuide = React.lazy(() => import("pages/Asset/UserGuide"));

// Marketing Campaign module (Phase 1) -- targeting/segmentation, template
// selection via PurpleRadianceNexus, immediate/scheduled email dispatch.
const CampaignCampaigns = React.lazy(() => import("pages/Campaign/Campaigns"));
const CampaignDetail = React.lazy(() => import("pages/Campaign/CampaignDetail"));
const CampaignNexusSettings = React.lazy(() => import("pages/Campaign/NexusSettings"));
const CampaignUserGuide = React.lazy(() => import("pages/Campaign/UserGuide"));

// Digitonic Admin Service -- PurpleRadiance company administration
// (company users, hospital/tenant onboarding, domain configuration, bulk
// medicine upload). NOT hospital/tenant-facing -- own login, own layout
// (AdminLayout, not Sidebar1), own sessionStorage token key ("adminToken").
const AdminLogin = React.lazy(() => import("pages/Admin/AdminLogin"));
const AdminLayout = React.lazy(() => import("pages/Admin/AdminLayout"));
const AdminCompanyUsers = React.lazy(() => import("pages/Admin/CompanyUsers"));
const AdminHospitals = React.lazy(() => import("pages/Admin/Hospitals"));
const AdminHospitalDomains = React.lazy(() => import("pages/Admin/HospitalDomains"));
const AdminMedicineBulkUpload = React.lazy(() => import("pages/Admin/MedicineBulkUpload"));
const AdminHrmsAccessOverview = React.lazy(() => import("pages/Admin/HrmsAccessOverview"));
const AdminIpdBillMethod = React.lazy(() => import("pages/Admin/IpdBillMethod"));

const reCaptchaKey = process.env.REACT_APP_RECAPTCHA;

function App() {
  const statusDoctor = sessionStorage.getItem("statusdoctor");

  // This is a multi-tenant system: hospital name/logo/branding is resolved
  // at runtime by CommonHospitalLoginPage itself (POST /api/hospital-domain/get,
  // keyed off the request's Host header in hospital-domain-service -- see
  // "Multi-tenancy / white-labeling" below) -- one build serves every
  // hospital's subdomain/custom domain, so root "/" no longer switches on a
  // build-time hospital name. Aurindam Hospital is kept as an explicit
  // special case (its own standalone marketing homepage, not the generic
  // login page) -- resolved by the actual browser hostname instead of a
  // build-time env var, matching the same "same build, per-domain
  // behavior" model. Every other domain falls through to the login page.
  const isAurindamDomain = ["aurindamhospital.com", "www.aurindamhospital.com"].includes(
    window.location.hostname,
  );

  const CurrentComponent = () => (
    <GoogleReCaptchaProvider
      reCaptchaKey={reCaptchaKey}
      key={reCaptchaKey}
      useRecaptchaNet={true} // Optional but improves reliability
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      {isAurindamDomain ? <HomeOne /> : <CommonHospitalLoginPage />}
    </GoogleReCaptchaProvider>
  );

  return (
    <React.Suspense
    // fallback={
    //   <div className="flex items-center justify-center h-screen">
    //     <div className="relative">
    //       <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-gray-200"></div>
    //       <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-blue-500 animate-spin"></div>
    //     </div>
    //   </div>
    // }
    >
      <HelmetProvider>
        <Helmet>
          {/* Static default -- per-hospital branding is no longer baked in
              at build time (see CurrentComponent above); a dynamic
              per-domain favicon would need to be set from the resolved
              hospital-domain-service response instead, which isn't wired
              up yet. */}
          <link rel="icon" href="/Digitonic.ico" />
        </Helmet>
      </HelmetProvider>
      <Router>
        <Routes>
          <Route path="/print-labels" element={<PrintLabels />} />s
          {/* Standalone, no Sidebar1 wrapper -- same reasoning as
              /print-labels above: a GST invoice opened in a new tab should
              print just the invoice, not the app's left navigation.
              Nesting it under the "/" Sidebar1 layout route below (as
              every other /pharmacy/* route is) would render the sidebar
              on-screen and in the print output too -- caught live when a
              printed invoice included the sidebar. */}
          <Route path="/pharmacy/print-invoice" element={<PharmacyPrintInvoice />} />
          {/* Standalone, no Sidebar1 wrapper and no login -- this is a
              public page reached by a patient scanning a hospital's QR
              code, so there is no session to nest it under. */}
          <Route path="/assessment/self-service" element={<AssessmentSelfServicePage />} />
          <Route path="/" element={<CurrentComponent />} />
          <Route path="/deleteaccount" element={<PatientDelete />} />
          <Route
            path="/sidebar"
            element={
              statusDoctor ? (
                <Sidebar1 />
              ) : (
                <GoogleReCaptchaProvider
                  // reCaptchaKey="6Le7PoIrAAAAAER8TFK1WBgt4m2pVcfuo275GqWk"
                  reCaptchaKey={reCaptchaKey}
                  key={reCaptchaKey}
                  useRecaptchaNet={true} // Optional but improves reliability
                  scriptProps={{
                    async: true,
                    defer: true,
                    appendTo: "head",
                    nonce: undefined,
                  }}
                >
                  <CommonHospitalLoginPage />
                </GoogleReCaptchaProvider>
              )
            }
          />
          {/* <Route
              path="/sidebar"
              element={statusDoctor ? <Sidebar1 /> : <LoginPageWrapper />}
            /> */}
          <Route
            path="/multispecialtyHospital"
            element={<MultispecialtyHospital />}
          />
          <Route path="/motherandchildcare" element={<MotherChildCare />} />
          <Route path="/speciality" element={<Speciality />} />
          <Route path="/doctorsone" element={<DoctorsOne />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<LogInEmpty />} />
          <Route path="/createUser" element={<CreateUser />} />
          <Route
            path="/loginfordoctor"
            element={
              <GoogleReCaptchaProvider
                // reCaptchaKey="6Le7PoIrAAAAAER8TFK1WBgt4m2pVcfuo275GqWk"
                reCaptchaKey={reCaptchaKey}
                key={reCaptchaKey}
                useRecaptchaNet={true} // Optional but improves reliability
                scriptProps={{
                  async: true,
                  defer: true,
                  appendTo: "head",
                  nonce: undefined,
                }}
              >
                <LoginDoctor />
              </GoogleReCaptchaProvider>
            }
          />
          {/* <Route path="/loginfordoctor" element={<LoginPageWrapper />} /> */}
          {/* {Digitonic} */}
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/resetpassword/:id" element={<PassWordReset />} />
          {/* Sant Tukaram Hospital */}
          <Route
            path="/createNewPatient"
            element={<SantTukaramHospitalNewPatient />}
          />
          <Route
            path="/forgotPatientPassword"
            element={<SantTukaramHospitalPatientForgotPassword />}
          />
          <Route
            path="/patientResetPaword/:id"
            element={<SantTukaramHospitalPatientResetPaword />}
          />
          {/* Nested routes for Doctor Login */}
          <Route path="/" element={<Sidebar1 />}>
            <Route path="/doctorhome" element={<DoctorHome />} />
            {/* {Book Appointments} */}
            <Route
              path="/appointmentsmanagements"
              element={<Appointmentsmanagements />}
            />
            <Route path="/bookappointment" element={<BookAppointment />} />
            <Route path="/appointment/add/patient" element={<AddPatient />} />
            <Route
              path="/appointment/booking/:patient_id"
              element={<BookappointmentAdd />}
            />
            <Route
              path="/appointmentmanagement/Update/:patient_id/:patient_signup_master_id"
              element={<UpdatePatientAppointmentsmanagements />}
            />
            <Route
              path="/appointment/add/uploadReport/:patient_id"
              element={<UploadReport />}
            />
            <Route
              path="/appointment/USGPreliminaryFrom/:patient_id/:id"
              element={<USGPreliminaryFrom />}
            />
            <Route
              path="/appointment/add/vitals/:patient_id/:id"
              element={<AddVitals />}
            />
            <Route
              path="/appointment/add/bill_view/:patient_id/:id"
              element={<AddBillView />}
            />
            {/* <Route
                path="/appointment/add/OpdBill/:patient_id/:id"
                element={<OpdBill />}
              /> */}
            <Route
              path="/appointment/add/OpdBill/:patient_id/:id"
              element={<AddBillView />}
            />
            <Route
              path="/appointment/collect/payment/:patient_id/:userdetail_id/:id"
              element={<MarkPaid />}
            />
            {/* {OPD} */}
            {/* {Appointments} */}
            <Route
              path="/doctorAppointments"
              element={<ApponitmentDoctorList />}
            />
            <Route path="/patientlist" element={<PatientList />} />
            <Route
              path="/patientlist/addpatient"
              element={<AddPatientByDoctor />}
            />
            <Route
              path="/appointment/add/:patient_id/:id"
              element={<Billing />}
            />
            <Route
              path="/appointment/bookingDoctor/:patient_id"
              element={<BookAppointmentByDoctor />}
            />
            <Route
              path="/consultaion/:key/:patient_id/:id"
              element={<ConsultationAll />}
            />
            <Route path="/opd/vaccination-due" element={<VaccinationDue />} />
            <Route
              path="/consultaion/add/symptom/:patient_id/:id"
              element={<AddNewSymtoms />}
            />
            <Route
              path="/doctorUSGPreliminaryFrom/:patient_id/:id"
              element={<DoctorUSGPreliminaryFrom />}
            />

            <Route
              path="/consultaion/add/medicine/:patient_id/:id"
              element={<AddNewMedicines />}
            />
            <Route
              path="/consultaion/AfterObstetricUsg/:patient_id/:userdetail_slot_id"
              element={<AfterObstetricUsg />}
            />
            <Route
              path="/consultaion/BeforeObstetricUsg/:patient_id/:userdetail_slot_id"
              element={<BeforeObstetricUsg />}
            />

            <Route
              path="/consultaion/add/instruction/:patient_id/:id"
              element={<AddNewInstruction />}
            />
            <Route
              path="/gynecology/:patient_id/:ipd_enrollment_id"
              element={<GynecologyPage />}
            />
            <Route
              path="/GynecologyPage/AfterObstetricUsg/:patient_id/:userdetail_slot_id"
              element={<GynecologyPageAfterObstetricUsg />}
            />
            <Route
              path="/GynecologyPage/BeforeObstetricUsg/:patient_id/:userdetail_slot_id"
              element={<GynecologyPageBeforeObstetricUsg />}
            />
            <Route
              path="/birth-report-form1/:birthRecordId/:patient_id"
              element={<Form1 />}
            />

            {/* {post operation orders} */}
            <Route
              path="/post-operation-orders-template"
              element={<PostOperationTemplate />}
            />
            <Route
              path="/add-post-operation-orders-template"
              element={<AddPostOperationTemplate />}
            />


            <Route
              path="/post-operation-orders"
              element={<PostOperationOrders />}
            />
            {/* {MyPatients} */}
            <Route path="/myPatients" element={<MyPatient />} />
            <Route path="/opdHistory/:id" element={<OpdHistoryNew />} />
            <Route path="/AllOpdHistory/:patient_id" element={<AllOpdHistory />} />
            <Route path="/OpdHistoryAllObstetricUsg" element={<OpdHistoryAllObstetricUsg />} />
            <Route path="/OPdHistoryPersonalNote" element={<OPdHistoryPersonalNote />} />
            <Route path="/OpdHistoryPreExistingConditions" element={<OpdHistoryPreExistingConditions />} />
            <Route path="/OpdHistoryUploadConsultationReport" element={<OpdHistoryUploadConsultationReport />} />
            <Route
              path="/History/update/:patient_id/:patient_signup_master_id"
              element={<MypatientUpdatePatient />}
            />
            {/* UsersList */}
            <Route path="/user/management/all" element={<UsersList />} />
            <Route path="/user/management/referral" element={<UserReferral />} />
            <Route path="/user/management/adduser" element={<AddUser />} />
            <Route
              path="/user/management/edituser/:id"
              element={<EditUser />}
            />
            <Route
              path="/user/management/profile/:id"
              element={<UserProfileAll />}
            />
            <Route
              path="/user/management/profile/access/:id"
              element={<UserAccess />}
            />
            <Route
              path="/user/management/profile/image/:id"
              element={<UserImageAddUpdate />}
            />
            {/* surgerlist */}
            <Route path="/SurgeryList/get" element={<SurgeryList />} />
            <Route path="/SurgeryList/add" element={<SurgeryListAdd />} />
            <Route
              path="/surgerylist/edit/:id"
              element={<SurgeryListEdit />}
            />
            {/* OperationTheater */}

            <Route
              path="/operationtheater/get"
              element={<OperationTheater />}
            />
            <Route
              path="/operationtheater/edit/:id"
              element={<OperationTheaterEdit />}
            />
            {/*OperationNotes*/}
            <Route
              path="/OperationNoteslist"
              element={<OperationNoteslist />}
            />
            <Route
              path="/OperationNotes/add/view/update/:surgery_list_id"
              element={<OperationNotesadd />}
            />
            <Route
              path="/Gynecology/add"
              element={<GynecologyOperationNotesAdd />}
            />
            <Route
              path="/newOperationNotes/Add/update"
              element={<NewOperationNotesAddupdate />}
            />
            <Route
              path="/Gynecology/update/:surgery_list_id/:specialization_id"
              element={<GynecologyOperationNotesupdate />}
            />

            {/* IPDTemplateCategory */}

            <Route
              path="/ipdregisterreport"
              element={<IPDRegisterReport />}
            />
            <Route
              path="/ipdtemplatecategory/edit/:id"
              element={<IPDTemplateCategoryEdit />}
            />
            {/* indication */}

            {/* <Route path="/indication/get" element={<Indication />} />
            <Route
              path="/editIndication/edit/:id"
              element={<EditIndication />}
            />
            <Route path="/addNewIndication" element={<AddNewIndication />} /> */}


            <Route
              path="/operationtheater/booking/get"
              element={<OperationTheaterBookingList />}
            />
            <Route
              path="/operationtheater/booking/create"
              element={<AddOTBooking />}
            />
            <Route
              path="/operationtheater/booking/edit/:id"
              element={<UpdateOTBooking />}
            />
            {/* hospital Settings */}
            <Route
              path="/hospitallabsetting"
              element={<LabSetting />}
            />
            <Route
              path="/hospitalsettings"
              element={<HospitalSettingDetails />}
            />
            <Route
              path="/billableItems/addOpdBill"
              element={<BillableItemsAddOpdBill />}
            />
            <Route
              path="/billableItems/editOpdBill/:id"
              element={<BillableItemsEditOpdBill />}
            />
            <Route
              path="/specialization/add"
              element={<SpecialzationAdd />}
            />
            <Route
              path="/specialization/edit/:id"
              element={<SpecializationUpdate />}
            />
            <Route
              path="/specialization/update/:id"
              element={<UpdateSpecialization />}
            />
            <Route
              path="/specialization/view/:id"
              element={<SpecializationImageView />}
            />
            <Route path="/symptoms/:id" element={<AddSymptoms />} />
            <Route path="/MyProfile/MyProfile" element={<MyProfile />} />
            <Route path="/MyProfile/MyProfile/:id" element={<MyProfile />} />
            <Route
              path="/MyProfile/UserProfileDocuments/:id"
              element={<UserProfileDocuments />}
            />
            <Route
              path="/user/management/edituser/:id"
              element={<EditUser />}
            />
            <Route
              path="/user/management/profile/:id"
              element={<UserProfileAll />}
            />
            {/* Hosital revenue reports */}
            <Route path="/opdrevenuereports"
              element={<OPDRevenueReports />} />

            <Route path="/ipdrevenuereports"
              element={<IPDRevenueReports />} />


            {/* Reports */}
            <Route path="/revenuereports" element={<RevenueReports />} />
            <Route path="/newpientsreports" element={<NewPientsReports />} />
            <Route path="/oldpientsreports" element={<OldPatientReports />} />
            <Route path="/topsymptomsreports" element={<TopSymptomsReports />} />
            <Route path="/UsgPreliminaryReport" element={<UsgPreliminaryReport />} />
            <Route path="/OperationTheaterBookingReport" element={<OperationTheaterBookingReport />} />
            <Route path="/AnaesthetistProcedureReport" element={<AnaesthetistProcedureReport />} />
            <Route
              path="/topdiagnosisreports"
              element={<TopDianosisreport />}
            />
            <Route path="/myreports" element={<MyReport />} />
            <Route path="/hospitalreports" element={<HospitalReport />} />

            {/* Lab Management */}

            <Route path="/samplecollection" element={<SampleCollection />} />
            <Route path="/incominglabrequest" element={<IncomingLabRequest />} />
            <Route path="/samplecollection/:labId" element={<SampleCollectionDetail />} />
            <Route path="/labworklist" element={<LabWorklist />} />
            <Route path="/labworklist/:id" element={<LabWorklistDetail />} />
            <Route path="/labtestverification" element={<LabTestVerification />} />
            <Route path="/labreport" element={<LabReport />} />
            <Route path="/laborders" element={<LabOrders />} />
            <Route path="/laborders/labbillandpay/:lab_order_id" element={<LabBillAndPay />} />
            <Route path="/labdashboard" element={<Dashboard />} />
            <Route path="/laborders/:labId/:serviceCategoryId/addpatient" element={<LabAddPatient />} />
            {/* <Route path="/hsnsac/all" element={<HsnSacAll />} />  
            <Route path="/Hsn/add" element={<HsnCreate />} />
            <Route path="/Hsn/update/:id" element={<HsnUpdate />} />
            <Route path="/Sac/add" element={<SacCreate />} />
            <Route path="/Sac/update/:id" element={<SacUpdate />} /> */}

            {/* Pharmacy */}
            <Route path="/pharmacy/pending-prescriptions" element={<PharmacyPendingPrescriptions />} />
            <Route path="/pharmacy/dispense-history" element={<PharmacyDispenseHistory />} />
            <Route path="/pharmacy/stock" element={<PharmacyStockInventory />} />
            <Route path="/pharmacy/grn" element={<PharmacyGrnList />} />
            <Route path="/pharmacy/grn/add" element={<PharmacyGrnCreate />} />
            <Route path="/pharmacy/purchase-order" element={<PharmacyPurchaseOrderList />} />
            <Route path="/pharmacy/stock-transfer" element={<PharmacyStockTransferList />} />
            <Route path="/pharmacy/ageing-report" element={<PharmacyAgeingReport />} />
            <Route path="/pharmacy/settings" element={<PharmacySettings />} />
            <Route path="/pharmacy/user-guide" element={<PharmacyUserGuide />} />
            <Route path="/pharmacy/stock-adjustment" element={<PharmacyStockAdjustment />} />
            <Route path="/pharmacy/return-to-supplier" element={<PharmacySupplierReturn />} />
            <Route path="/pharmacy/supplier-adjustment" element={<PharmacySupplierAdjustment />} />
            <Route path="/pharmacy/supplier-reports" element={<PharmacySupplierReports />} />
            <Route path="/pharmacy/revenue-reports" element={<PharmacyRevenueReports />} />
            <Route path="/pharmacy/patient-return" element={<PharmacyPatientReturn />} />
            <Route path="/pharmacy/expiry-writeoff" element={<PharmacyExpiryWriteoff />} />
            <Route path="/pharmacy/print-medicine-barcode" element={<PharmacyPrintMedicineBarcode />} />
            <Route path="/pharmacy/regulated-register" element={<PharmacyRegulatedRegister />} />
            <Route path="/pharmacy/print-regulated-register" element={<PharmacyPrintRegulatedRegister />} />
            <Route path="/pharmacy/stock-take" element={<PharmacyStockTake />} />
            <Route path="/pharmacy/abc-ved-analysis" element={<PharmacyAbcVedAnalysis />} />
            <Route path="/pharmacy/print-abc-ved-analysis" element={<PharmacyPrintAbcVedAnalysis />} />

            <Route path="/hrms/dashboard" element={<HrmsDashboard />} />
            <Route path="/hrms/my-profile" element={<HrmsMyProfile />} />
            <Route path="/hrms/personnel" element={<HrmsPersonnel />} />
            <Route path="/hrms/attendance" element={<HrmsAttendance />} />
            <Route path="/hrms/leave" element={<HrmsLeave />} />
            <Route path="/hrms/my-team" element={<HrmsMyTeam />} />
            <Route path="/hrms/payroll" element={<HrmsPayroll />} />
            <Route path="/hrms/doctor-payout" element={<HrmsDoctorPayout />} />
            <Route path="/hrms/settlement-detail/:id" element={<HrmsSettlementDetail />} />
            <Route path="/hrms/settings" element={<HrmsSettings />} />
            <Route path="/hrms/audit-log" element={<HrmsAuditLog />} />
            <Route path="/hrms/user-guide" element={<HrmsUserGuide />} />

            <Route path="/asset/assets" element={<AssetAssets />} />
            <Route path="/asset/assets/:id" element={<AssetDetail />} />
            <Route path="/asset/amc-expiring" element={<AssetAmcExpiring />} />
            <Route path="/asset/bulk-upload" element={<AssetBulkUpload />} />
            <Route path="/asset/user-guide" element={<AssetUserGuide />} />

            <Route path="/campaign/campaigns" element={<CampaignCampaigns />} />
            <Route path="/campaign/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/campaign/nexus-settings" element={<CampaignNexusSettings />} />
            <Route path="/campaign/user-guide" element={<CampaignUserGuide />} />

            <Route path="/laborders/addpatient" element={<LabAddPatient />} />

            {/* radiology management */}

            <Route path="/incomingradiologyrequest" element={<IncomingRadiologyRequest />} />

            <Route path="/radiologyorders" element={<RadiologyOrder />} />
            <Route path="/radiologyworklist" element={<Radiologyworklist />} />
            <Route path="/radiologyworklist/:id" element={<RadiologyworklistDetail />} />
            <Route path="/radiologyverification" element={<Radiologyverification />} />
            <Route path="/radiologyreports" element={<RadiologyReports />} />
            <Route path="/radiologyorders/radiologybillandpay/:radiology_order_id" element={<RadiologyBillAndPay />} />

            {/* hsn and sac */}
            <Route path="/hsnsac/all" element={<HsnSacMaster />} />



            {/* ReportUSGPatient */}
            <Route path="/reportUSGpatient" element={<ReportUSGPatient />} />
            {/* ReportPreExistingCondition */}
            <Route
              path="/reportpreexistingcondition"
              element={<ReportPreExistingCondition />}
            />
            {/* OPD Management */}
            <Route path="/settings" element={<OPDManagementAll />} />
            <Route
              path="/settings/imageupload"
              element={<MyProfileImageAddUpdate />}
            />
            {/* Patient Management */}
            <Route
              path="/patientmanagement/allpatientlist"
              element={<PatientManagementList />}
            />
            <Route
              path="/Patientmanagement/addpatient"
              element={<PatientManagementAddPatient />}
            />
            <Route
              path="/Patientmanagement/update/:patient_id/:patient_signup_master_id"
              element={<PatientManagementUpdatePatient />}
            />
            {/* Room Booking */}
            <Route
              path="/ipd/gynecologypage/afterobstetricusg/:patient_id/:userdetail_slot_id"
              element={<GynecologyPageAfterObstetricUsg />}
            />
            <Route
              path="/ipd/gynecologypage/beforeobstetricusg/:patient_id/:userdetail_slot_id"
              element={<GynecologyPageBeforeObstetricUsg />}
            />
            <Route
              path="/roombooking/admissiondetails"
              element={<RoomBookingAdmissionDetails />}
            />
            <Route
              path="/roombooking/addpatient"
              element={<RoomBookingAddPatient />}
            />
            <Route
              path="/roombooking/editpatient/:SelectedpatientId"
              element={<RoomBookingEditPatient />}
            />
            <Route
              path="/roombooking/PatientManage"
              element={<RoomBookingPatientManage />}
            />
            <Route path="/ipdDetails/:id" element={<IpdDetails />} />
            <Route path="/ipd/tpa-insurance" element={<IpdTpaInsurance />} />
            <Route path="/ipd/tpa-reports" element={<TpaReports />} />
            <Route
              path="/roombooking/patient-manage/:id/:bedId"
              element={<ManagePatientRoomBookin />}
            />
            <Route path="/roombooking" element={<RoomBooking />} />
            <Route
              path="/roombooking/iPDEditPatient/:SelectedpatientId"
              element={<IPDEditPatient />}
            />
            <Route
              path="/roombooking/:SelectpatientId"
              element={<RoomBooking />}
            />
            <Route
              path="/roombooking/CheckBedAvailability/:SelectedpatientId"
              element={<CheckBedAvailability />}
            />
            <Route
              path="/roombooking/CheckBedAvailabilitytwo/:id/:bedId"
              element={<CheckBedAvailabilitytwo />}
            />
            {/* {update  Medicine} */}
            <Route path="/updateMedicine" element={<UpdateMedicine />} />
            <Route path="/addHospitaltest" element={<AddHospitalTest />} />
            <Route path="/addTestCategory" element={<AddTestCategory />} />
            <Route
              path="/editHospitalTest/:id"
              element={<EditHospitalTest />}
            />
            <Route
              path="/updateHospitalTestCategory/:id"
              element={<UpdateHospitalTestCategory />}
            />
            <Route path="/hospitalAllTest" element={<HospitalAllTest />} />

            <Route path="/ipdbillsetup" element={<IPDBillingSetup />} />
            <Route path="/ipdAddNewBillItem" element={<AddNewBillItem />} />
            <Route
              path="/ipdEditBillItem/:id"
              element={<UpdateNewBillItem />}
            />
            <Route
              path="/addNewBillCaregory"
              element={<AddNewBillCategory />}
            />
            <Route
              path="/editBillCategory/:id"
              element={<UpdateNewBillCategory />}
            />

            <Route path="/ipdBillAndPay/:id" element={<IPDBillAndPay />} />
            <Route
              path="/ipdDichargeSummary/:id"
              element={<IPDDischargeMain />}
            />
            <Route
              path="/ipdDischargeSetup"
              element={<IPDDischargeSetup />}
            />
            <Route
              path="/ipdDischargeSetup/checklist/update/:id"
              element={<IPDDichargeCheckListUpdate />}
            />
            <Route
              path="/ObstetricUsglist/update/:id"
              element={<ObstetricUsglistUpdate />}
            />

            {/* IPD Consultation */}
            <Route
              path="/roombooking/ipddoctorvisit/:key/:id/:patient_id/:ipd_visiting_round_id"
              element={<IpdConsultation />}
            />
            <Route
              path="/roombooking/ipdhistory/:ipd_enrollment_id/:patient_id"
              element={<IpdHistory />}
            />

            {/* master service category */}
            <Route path="/ipdsettings" element={<IPDSettings />} />
            <Route path="/opdsettings" element={<OPDSettings />} />
            {/* hospital IPD Bed Setup */}
            <Route path="/ipdbedsetup" element={<IPDBedSetup />} />
            <Route path="/ipdwardcreate" element={<IpdWardcreate />} />
            <Route path="/ipdwardupdate/:id" element={<IpdWardUpdate />} />
            <Route path="/ipdbedcreate" element={<IpdBedcreate />} />
            <Route path="/ipdbedupdate" element={<IpdBedUpdate />} />
            <Route
              path="/ipdwardtypecreate"
              element={<IpdWardTypecreate />}
            />
            <Route path="/ipdwrdtypeupdate" element={<IpdWrdTypeUpdate />} />
            {/* hospital religin Setup */}
            <Route path="/religinDisplay" element={<ReliginDisplay />} />
            {/* ipd template Setup */}
            {/* <Route
                path="/ipdTemplateSetup"
                element={<IPDMasterTemplateSetup />}
              /> */}
            <Route path="/ipdTemplateSetup" element={<IPDTamplateNavTab />} />
            <Route
              path="/ipdTemplateupdate/:id"
              element={<EditIPDMasterTemplate />}
            />
            <Route
              path="/ipdTemplateadd"
              element={<AddIPDMasterTemplate />}
            />
          </Route>

          {/* Digitonic Admin Service -- PurpleRadiance company admin, own
              layout (AdminLayout, not Sidebar1), own login/session, NOT
              hospital/tenant-facing. See CLAUDE.md "Digitonic Admin Service". */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="hospitals" element={<AdminHospitals />} />
            <Route path="hospital-domains" element={<AdminHospitalDomains />} />
            <Route path="medicine-upload" element={<AdminMedicineBulkUpload />} />
            <Route path="company-users" element={<AdminCompanyUsers />} />
            <Route path="hrms-access-overview" element={<AdminHrmsAccessOverview />} />
            <Route path="ipd-bill-method" element={<AdminIpdBillMethod />} />
          </Route>

          <Route path="/oTPFormDoctor" element={<OTPFormDoctors />} />
          <Route
            path="/passwordResetFormDoctors/:id"
            element={<PasswordResetFormDoctors />}
          />
          <Route path="/" element={<Sidebar2 />}>
            <Route path="/patientHome" element={<PatientHome />} />
            <Route
              path="/patient/allFamilyMembers"
              element={<AllFamilyMembers />}
            />
            <Route
              path="/patient/updatePatient/:id"
              element={<EditPatient />}
            />
            <Route
              path="/patient/addNewPatient"
              element={<AddNewPatient />}
            />
            <Route
              path="/patient/addPatientProfile/:id"
              element={<AddNewPatientProfile />}
            />
            <Route
              path="/patient/viewPatientProfile/:id"
              element={<ViewPatientProfile />}
            />
            <Route path="/patient/bookByDoctor" element={<BookByDoctor />} />
            <Route
              path="/patient/bookByDoctor/:id"
              element={<BookByDoctor />}
            />
            <Route path="/bookByDoctor/:name" element={<BookByDoctor />} />
            <Route
              path="/patient/bookAppointmentSlot/:userDetailId/:name/:expertise/:qualification_description"
              element={<BookAppointmentSlot />}
            />
            <Route
              path="/patient/bookBySpecialization"
              element={<BookBySpecialization />}
            />
            <Route
              path="/patient/bookBysymptoms"
              element={<BookBySymptom />}
            />
            <Route path="/patient/appointment" element={<Appointments />} />
            <Route
              path="/patient/bookByAppointmentSymptom/:name"
              element={<BookAppointmentSymptom />}
            />
            <Route path="/patient/viewProfile" element={<ViewProfile />} />
            <Route
              path="/patient/updatePasswardPatient"
              element={<UpdatePasswardPatient />}
            />
            <Route
              path="/patient/uploadReport/:patient_id"
              element={<AppointmentUploadReport />}
            />
          </Route>
          <Route path="/patient/oTPForm" element={<OTPForm />} />
          <Route
            path="/patient/passwordResetForm/:id"
            element={<PasswordResetForm />}
          />
          <Route
            path="/ipdSummary/:id/:token"
            element={<IPDDischargeSummaryForAndroid />}
          />
        </Routes>
      </Router>
    </React.Suspense>
  );
}

export default App;
